export default "__VITE_ASSET__fcb9aeeb__"